<template>
    <NuxtLink
        v-if="title && to"
        class="cta-card"
        :class="{
            'cta-card--small': small,
            'cta-card--medium': medium,
            'cta-card--large': large,
            'cta-card--responsive': !small && !medium && !large && !inline,
            'cta-card--inline': inline
        }"
        :style="{ backgroundColor }"
        :to
        @mouseover="hovering = true"
        @mouseout="hovering = false"
    >
        <slot name="image">
            <BaseImage
                v-if="image"
                sizes="(min-width: 1300px) 200px, (min-width: 501px) 150px, 100px"
                :image="image"
                :title="image?.title"
                :width="image?.width"
                :height="image?.height"
            />
        </slot>
        <div class="cta-card__title">{{ title }}</div>

        <div v-if="!inline" class="cta-card__description">{{ description }}</div>
        <BaseButton
            v-if="!inline"
            secondary
            element="div"
            icon="marker:arrow_1_right"
            :hover="hovering"
            :label="ctaLabel"
        />
        <Icon v-if="inline" name="marker:arrow_1_right" class="cta-card__arrow" />
    </NuxtLink>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true,
        default: null
    },
    to: {
        type: [String, Object],
        required: true,
        default: null
    },
    description: {
        type: String,
        required: false,
        default: null
    },
    image: {
        type: Object,
        required: false,
        default: null
    },
    ctaLabel: {
        type: String,
        required: false,
        default: null
    },
    backgroundColor: {
        type: String,
        required: false,
        default: null
    },
    small: {
        type: Boolean,
        required: false,
        default: false
    },
    medium: {
        type: Boolean,
        required: false,
        default: false
    },
    large: {
        type: Boolean,
        required: false,
        default: false
    },
    inline: {
        type: Boolean,
        required: false,
        default: false
    }
});

const hovering = ref(false);
</script>

<style lang="less" src="./CtaCard.less" />
